import { type FC } from 'react';

import { useTranslation } from '@mint-lib/i18n';

import { Alert, Box, CheckboxWithLabel, Typography } from '@myn/mui';

type Props = {
  content: string;
  toggleDoNotShowAgain: () => void;
  alertData?: string;
};

const ContentWithCheckbox: FC<Props> = ({
  content,
  alertData,
  toggleDoNotShowAgain,
}) => {
  const { t } = useTranslation('@myn/planning');

  return (
    <Box>
      <Typography variant="bodyLong01" sx={{ display: 'inline-block', mb: 2 }}>
        {content}
      </Typography>
      {alertData && <Alert severity="info" sx={{ mb: 2 }} title={alertData} />}
      <CheckboxWithLabel
        label={t("Don't show it again")}
        onChange={toggleDoNotShowAgain}
      />
    </Box>
  );
};

export default ContentWithCheckbox;
